import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination
} from "@mui/material";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import SaveIcon from "@mui/icons-material/Save";
import { Card, Alert } from "reactstrap";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { AiOutlineSearch } from "react-icons/ai";
import SearchIcon from "@mui/icons-material/Search";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { swalWithBootstrapButtons } from "../../utils/sweetalert";
import { getriskRuleList } from "../../redux/actions/riskRulesListAction";
import { getUpdateRiskList } from "../../redux/actions/updateRiskRulesAction";
import { IoMdSave } from "react-icons/io";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const SendLimit = () => {
	const classes = useStyles();
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [show, setShow] = useState(true);
	const [ruleStatusValue, setRuleStatusValue] = useState([]);
	const [user, setUser] = useState({
		ruleID: "",
		riskGroup: "",
		Status: "",
		ruleeStatus: "Enable"
	});
	const { ruleID, riskGroup, Status, ruleeStatus } = user;

	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};

	const dispatch = useDispatch();
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getAllWalletsListRes = useSelector(
		({ riskRulesList }) => riskRulesList
	);
	// console.log("getAllWalletsListRes", getAllWalletsListRes);

	// Limit
	var limit =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.limit;
		});

	// console.log("limit", limit);

	// riskScore

	var riskScore =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.riskScore;
		});

	// console.log("riskScore", riskScore);

	// ruleId

	var ruleId =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.ruleId;
		});

	// console.log("ruleId", ruleId);

	// ruleName

	var ruleName =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.ruleName;
		});
	// console.log("ruleName", ruleName);

	// ruleStatus

	var ruleStatus =
		getAllWalletsListRes.success &&
		getAllWalletsListRes.data.riskRuleList &&
		[].concat(getAllWalletsListRes.data.riskRuleList).map((row, index) => {
			return row.ruleStatus;
		});

	// console.log("ruleStatus", ruleStatus);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const getAllWalletsListApi = () => {
		setShow(false);
		const getAllWalletsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				ruleId: ruleID,
				riskGroup: riskGroup,
				ruleStatus: Status
			}
		};

		return dispatch(getriskRuleList(getAllWalletsListReq, authToken));
	};

	var obj = ruleStatusValue;

	const getCurrIdx = (idx, value) => {
		obj[idx].ruleStatus = value;
		// console.log(ruleStatusValue, "obj");
		setRuleStatusValue([]);
		setRuleStatusValue([].concat(obj));
	};

	// getupdateRiskRule

	const getupdateRiskRule = () => {
		const Req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			riskRuleList: [
				{
					limit: limit,
					riskScore: riskScore,
					ruleId: ruleId,
					ruleName: ruleName,
					ruleStatus: ruleStatusValue
				}
			]
		};
		if (updateRiskRule.success) {
			swalWithBootstrapButtons.fire({
				type: "success",
				title: "Record Udated SuccessFully"
			});
		}

		return dispatch(getUpdateRiskList(Req, authToken));
	};

	const updateRiskRule = useSelector(({ updateRiskRule }) => updateRiskRule);
	// console.log("updateRiskRule", updateRiskRule);

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem"
						}}
					>
						<Grid item md={8} sm={12} lg={8}></Grid>
						<Grid item md={4} sm={12} lg={4}>
							<NavLink to="/index/SL-send-limit">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add New Send Limit
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									// onClick={handleNoticationClose}
									// endIcon={<SaveIcon />}
								>
									Add New Send Limit
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								size="small"
								type="text"
								label=" Rule ID"
								fullWidth={true}
								color="primary"
								autoFocus={true}
								name="ruleID"
								value={ruleID}
								onChange={(e) => onInputChange(e)}
							/>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Risk Group"
								fullWidth={true}
								name="riskGroup"
								value={riskGroup}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Redeem">Redeem</MenuItem>
								<MenuItem value="Purchase ">Purchase</MenuItem>
							</TextField>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Status"
								fullWidth={true}
								name="Status"
								value={Status}
								onChange={(e) => onInputChange(e)}
							>
								<MenuItem value="Enable">Enable</MenuItem>
								<MenuItem value="Disable">Disable</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getAllWalletsListApi}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								// onClick={getAllWalletsListApi}
								// endIcon={<SaveIcon />}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{show ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Typography className="themeText" variant="body1">
								{" "}
								Default Rule List
							</Typography>
							<Grid sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<TableContainer component={Paper}>
						<Table
							className={classes.table}
							size="small"
							aria-label="a dense table"
						>
							<TableHead>
								<TableRow className="tableHeaderColor">
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Rule ID{" "}
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Rule Name{" "}
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Risk Group
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Score
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Limit
									</TableCell>
									<TableCell
										align="center"
										style={{ fontWeight: "bold", color: "white" }}
									>
										Status
									</TableCell>
									{/* <TableCell align="center">Action</TableCell> */}
								</TableRow>
							</TableHead>

							<TableBody>
								{getAllWalletsListRes.success &&
									getAllWalletsListRes.data.riskRuleList &&
									[]
										.concat(getAllWalletsListRes.data.riskRuleList)
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => (
											<TableRow key={row.ruleId}>
												<TableCell align="center">{row.ruleId}</TableCell>
												<TableCell align="center">{row.ruleName}</TableCell>
												<TableCell align="center">{row.riskGroup}</TableCell>
												<TableCell align="center">
													<TextField
														value={row.max_transaction_amount}
														size="small"
														color="primary"
														autoFocus={true}
														variant="outlined"
														fullWidth={true}
													>
														{" "}
														{row.max_transaction_amount}
													</TextField>
												</TableCell>
												<TableCell align="center">
													<TextField
														value={row.min_transaction_amount}
														size="small"
														color="primary"
														autoFocus={true}
														variant="outlined"
														fullWidth={true}
													>
														{row.min_transaction_amount}
													</TextField>
												</TableCell>
												<TableCell align="center">
													<TextField
														select
														size="small"
														color="primary"
														autoFocus={true}
														// label="role"
														variant="outlined"
														fullWidth={true}
														name="ruleeStatus"
														value={row.ruleStatus}
														onChange={(e) => onInputChange(e)}
													>
														<MenuItem
															onClick={() => getCurrIdx(index, "Y")}
															value={"Y"}
														>
															Enable
														</MenuItem>
														<MenuItem
															onClick={() => getCurrIdx(index, "N")}
															value={"N"}
														>
															Disable
														</MenuItem>
													</TextField>
												</TableCell>
											</TableRow>
										))}
							</TableBody>
						</Table>

						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={[].concat(getAllWalletsListRes.data.riskRuleList).length}
							rowsPerPage={rowsPerPage}
							page={page}
							onChangePage={handleChangePage}
							onChangeRowsPerPage={handleChangeRowsPerPage}
						/>
						<Grid container>
							<Grid item md={5} lg={5}></Grid>
							<Grid item md={2} lg={2}>
								{/* <Button
                  variant="contained"
                  style={{
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  size="small"
                  className="my-2"
                  endIcon={<IoMdSave />}
                  onClick={getupdateRiskRule}
                >
                  Save
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={getupdateRiskRule}
								>
									Save <SaveIcon />
								</CustomButton>
							</Grid>
							<Grid item md={5} lg={5}></Grid>
						</Grid>
					</TableContainer>
				)}
			</Layout>
		</>
	);
};

export default SendLimit;
